import { useEffect, useMemo, useState } from 'react';
import { createHttpClient } from '@wix/http-client';

import { useInitialState } from '../contexts/InitialStateContext';
import { Template } from '../domain/entities/template';
import { useSelectedCategoryId } from './useSelectedCategoryId';
import { HttpTemplateRepository } from '../domain/repositories/HttpTemplateRepository';
import { useFedopsLogger } from '../contexts/FedopsLoggerContext';

type State = {
  templates?: Template[];
  categoryId?: string;
};

export const useTemplates = () => {
  const initialState = useInitialState();
  const fedopsLogger = useFedopsLogger();
  const [state, setState] = useState<State>({
    templates: initialState.templates,
    categoryId: initialState.categoryId,
  });
  const categories = useMemo(
    () => initialState.book?.categories ?? [],
    [initialState.book],
  );
  const selectedCategoryId = useSelectedCategoryId({ categories });

  useEffect(() => {
    if (
      selectedCategoryId !== state.categoryId &&
      selectedCategoryId !== undefined
    ) {
      const templateRepository = new HttpTemplateRepository(createHttpClient());

      templateRepository
        .loadTemplates({
          categoryId: selectedCategoryId,
          language: initialState.locale,
        })
        .then((domainTemplates) => {
          setState({
            templates: domainTemplates,
            categoryId: selectedCategoryId,
          });
        })
        .finally(() => fedopsLogger.stopActiveInteraction());
    }
  }, [fedopsLogger, initialState.locale, selectedCategoryId, state.categoryId]);

  return state.templates;
};
